import { Helper } from '../../Helper';
export class InObjectPropertyHelperBase extends Helper {
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.findObjectPropertyBase({
            whenHasProperty: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                sb.emitPushBoolean(node, true);
            },
            whenNotHasProperty: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                sb.emitPushBoolean(node, false);
            },
            getObject: this.getObject.bind(this),
        }));
    }
}

//# sourceMappingURL=InObjectPropertyHelperBase.js.map
